export const useHelpers = () => {
    
    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const isDayThirtyOne = (date) => {
        // Dividimos la fecha en partes usando el separador '-'
        const [year, month, day] = date.split('-');
    
        // Convertimos el día a un número
        const dayNumber = parseInt(day, 10);
    
        // Verificamos si el día es 31
        return dayNumber === 31;
    }

    const paymentCalculation = (monto_venta, monto_enganche, interes, plazo) => {

        // console.log(monto_venta, monto_enganche, interes, plazo);

        const plazo_parse = parseInt(plazo);
        const monto_venta_parse = parseFloat(monto_venta);
        const monto_enganche_parse = parseFloat(monto_enganche);
        const interes_parse = parseFloat((interes/100).toFixed(4));

        // console.log(plazo_parse, monto_venta_parse, monto_enganche_parse, interes_parse);
        
        
        const saldo_financiar = ((monto_venta_parse - monto_enganche_parse) * interes_parse)
        const cuota_niv = parseFloat(saldo_financiar) / (1 - Math.pow((1 + interes_parse), - plazo_parse));
        const cuota_niv_format = cuota_niv.toFixed(2) 

        // console.log(interes_parse, saldo_financiar, cuota_niv, cuota_niv_format);
        return isNaN(cuota_niv_format) ? 0 : cuota_niv_format
      
    }

    const porcentajeToFloat = (cadena) => {
        const value = cadena.replace("%", "").trim();
        return parseFloat(value)
    }

    const convertToFloat = (formattedNumber) => {
        const cleanedValue = formattedNumber.replace(/,/g, '');
        const floatValue = parseFloat(cleanedValue);
        return isNaN(floatValue) ? 0 : floatValue; // Retorna 0 si no es un número válido
    };
      
    
    return Object.freeze({
        getCurrentDate,
        isDayThirtyOne,
        paymentCalculation,
        porcentajeToFloat,
        convertToFloat
    })
}